<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import dateMixin from '../../mixins/dateMixin';

export default {
  name: 'ReminderRulesRevisions',
  mixins: [
    dateMixin,
  ],
  props: {
    currentRevision: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 25,
      },
      search: undefined,
    };
  },
  computed: {
    ...mapState({
      revisions: state => state.reminders.rules.revisions,
    }),
    ...mapGetters({
      headers: 'reminders/getRevisionHeaders',
    }),
    filteredRevisions() {
      return this.revisions.items.filter((item) => {
        if (!this.search) {
          return true;
        }
        if (String(item.revision) === this.search) {
          return true;
        }
        const name = `${item.user.firstName} ${item.user.lastName}`;
        return name.indexOf(this.search) !== -1;
      });
    },
  },
  methods: {
    ...mapActions({
      setRevision: 'reminders/setRevision',
    }),
    updateRevision(revision) {
      this.setRevision(revision);
    },
  },
};
</script>

<template>
  <v-layout wrap mt-5>
    <v-flex xs12>
      <span class="headline font-weight-bold">Revisions</span>
    </v-flex>

    <v-flex xs12>
      <v-divider/>
    </v-flex>

    <v-flex xs3 mt-3>
      <v-text-field
        v-model="search"
        label="Search"
        placeholder="revision or user name"
        clearable
        hide-details
      />
    </v-flex>

    <v-flex xs12>
      <v-data-table
        :headers="headers"
        :items="filteredRevisions"
        :loading="revisions.loading"
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
          <tr :class="{ 'blue lighten-5': currentRevision === props.item.revision }">
            <td>{{ props.item.revision }}</td>
            <td>{{ formatDate(props.item.createdAt) }}</td>
            <td>{{ `${props.item.user.firstName} ${props.item.user.lastName}` }}</td>
            <td>
              <v-btn
                :disabled="currentRevision === props.item.revision"
                color="info"
                small
                @click="updateRevision(props.item.revision)"
              >
                View
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/Reminders/ReminderRulesRevisions.vue